export const sendConfig = {
    headers: {
      "Content-Type": "application/json",
    },
};

export const tokenConfig = {
    // "x-auth-token": localStorage.getItem("token"),
    headers: {
        accept: "/*/",
        Authorization: "Bearer " + localStorage.getItem("shreeDevToken"),
    },
};